import Svg from "assets/svg"
import { SocialPlatformEnum } from "utils/enums/scrapingENUM"
interface SocialNetworkProps {
    social: SocialPlatformEnum
}
export const SocialNetwork: React.FC<SocialNetworkProps> = ({ social }) => {
    const socialNetwork = {
        [SocialPlatformEnum.FACEBOOK]:<Svg.facebook />,
        [SocialPlatformEnum.TWITTER]: <Svg.twitter />,
        [SocialPlatformEnum.INSTAGRAM]: <Svg.instagram />,
        [SocialPlatformEnum.LINKEDIN]: <Svg.instagram />,
        [SocialPlatformEnum.REDDIT]: <Svg.reddit />,
    }
    return socialNetwork[social] || <Svg.reddit />
}